// Mock data for Cherry Stone Pte Ltd website

export const companyInfo = {
  name: 'Cherry Stone',
  fullName: 'Cherry Stone Pte Ltd',
  logoUrl:
    'https://static.wixstatic.com/media/d176e6_5833c8f94f8b4c9a98346ed4585af7e5~mv2.png/v1/fill/w_90,h_96,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/CherryStone_003.png',
  tagline: 'Timeless Stone. Crafted for Life.',
  founded: 'Founded by Ivy',
  phone1: '+65 6362 6860',
  phone2: '+65 9738 1331',
  whatsapp: '6597381331',
  email: 'ivy@cherrystone.com.sg',
  hrEmail: 'operations@cherrystone.com.sg',
  address: '35C Benoi Road, Pioneer Lot, Singapore 627792',
  instagram: 'https://www.instagram.com/cherrystonesg/',
  announcement: 'We\u2019ve moved to Pioneer Lot \u2014 35C Benoi Road',
};

export const aboutText = [
  'Following her passion in the trade of the supply and installation of stone products, the founder, Ivy, incorporated Cherry Stone Pte Ltd.',
  'The scope of Cherry Stone\u2019s business includes the supply, in-house fabrication and installation of stone products such as marble, granite and quartz. Since its inception, Cherry Stone has supplied and installed stone products for reputable hotels, shopping malls, office buildings, residential buildings and individual homes.',
  'Notable projects include the National Art Gallery, Novena Church and Mandarin Oriental Hotel. Leveraging on its founder\u2019s wealth of experience, Cherry Stone prides itself in supplying and installing stone products that best suit the customised needs of each valued customer.',
];

export const services = [
  {
    id: 'supply',
    title: 'Supply',
    subtitle: 'A curated range of the world\u2019s finest stones',
    description:
      'We supply a wide selection of stones including marble, granite, limestone, sandstone, onyx, travertine, terrazzo, quartz and sintered stone \u2014 sourced from trusted quarries worldwide.',
    image: 'https://images.unsplash.com/photo-1587749158407-58ef2b89ccf8?w=1200&q=80',
    icon: 'Layers',
    href: '#stones',
  },
  {
    id: 'fabrication',
    title: 'Fabrication',
    subtitle: 'In-house workshop, precision-crafted',
    description:
      'Our experienced fabricators bring your vision to life. From bespoke edges to complex cut-outs and book-matched slabs, every piece is finished with obsessive attention to detail.',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/10w8wmag_Fabrication.png',
    icon: 'Hammer',
    href: '#contact',
  },
  {
    id: 'installation',
    title: 'Installation',
    subtitle: 'Skilled hands, seamless finish',
    description:
      'A seasoned installation crew ensures every slab is set with millimetre accuracy \u2014 delivering a finish that lasts a lifetime, in homes, hotels, offices and civic landmarks.',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/xubm5smy_Installation.jpeg',
    icon: 'Wrench',
    href: '#contact',
  },
];

// Original stone imagery pulled from cherrystone.com.sg/supply
const wix = (path, name) =>
  `https://static.wixstatic.com/media/${path}/v1/fill/w_820,h_560,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/${encodeURIComponent(
    name
  )}.jpg`;

export const stones = [
  {
    name: 'Marble',
    description:
      'A metamorphic rock formed when limestone meets heat and pressure. Prized worldwide for its luminous veining and timeless beauty.',
    images: [
      wix('fab428_04554089634d4a08a4505d4911efde35~mv2.jpg', 'Marble 1'),
      wix('fab428_8f394cc6e56447aa815d74ea002b72ed~mv2.jpg', 'Marble 2'),
    ],
  },
  {
    name: 'Granite',
    description:
      'An igneous rock of coarse crystalline grain. Exceptionally hard, scratch-resistant and elegant \u2014 ideal for kitchens and high-traffic surfaces.',
    images: [
      wix('fab428_c70ba56a0c6a4f12a8575669a62b3bee~mv2.jpg', 'Granite 1'),
      wix('fab428_e4956846a3ab4903b80ce86acfae2ba5~mv2.jpg', 'Granite 2'),
    ],
  },
  {
    name: 'Limestone',
    description:
      'A carbonate sedimentary rock. Understated, long-lasting and beautifully weather-resistant \u2014 a classic since the 19th century.',
    images: [
      wix('fab428_a34f2aa07ced46fba6a073036590aab0~mv2.jpg', 'Limestone 1'),
      wix('fab428_bee01718a1164ec081cc07cd27d88d67~mv2.jpg', 'Limestone 2'),
    ],
  },
  {
    name: 'Sandstone',
    description:
      'A sedimentary rock with warm, natural texture. Versatile for bathrooms, kitchens, columns and outdoor structures.',
    images: [
      wix('fab428_43b53404ed724843bb840e0d9b4e4424~mv2.jpg', 'Sandstone 1'),
      wix('fab428_515572ba854048fe9fa8f99377ec55ad~mv2.jpg', 'Sandstone 2'),
    ],
  },
  {
    name: 'Onyx',
    description:
      'A translucent stone with a sparkling depth. Backlit, it transforms walls, bars and feature panels into sculptural light.',
    images: [
      wix('fab428_df22fe9ab7634454a2ab0f02dd1c212d~mv2.jpg', 'Onyx 4'),
      wix('fab428_17cb6473fcdc4bf2a0f1ac3625192a25~mv2.jpg', 'Onyx 2'),
    ],
  },
  {
    name: 'Travertine',
    description:
      'A form of limestone deposited by mineral springs. A modern architectural favourite for fa\u00e7ades, cladding and flooring.',
    images: [
      wix('fab428_4969dafe588041679db910f0feb05b53~mv2.jpg', 'Travertine 1'),
      wix('fab428_20c300bc95f444b786819053c15abed5~mv2.jpg', 'Travertine 2'),
    ],
  },
  {
    name: 'Terrazzo',
    description:
      'A composite of marble, quartz and glass chips set in binder. Durable, playful and rich with pattern.',
    images: [
      wix('fab428_8cc48df5ac1b4ec29da433d3790f0c1f~mv2.jpg', 'Terrazzo 1'),
      wix('fab428_90f82c2a54ce4604a7fed4ec3bf11e18~mv2.jpg', 'Terrazzo 2'),
    ],
  },
  {
    name: 'Quartz',
    description:
      'Engineered stone made from quartz aggregate and resins. Non-porous, durable and available in refined contemporary finishes.',
    images: [
      wix('fab428_18eb9d6741e34005b5ee78aae8b7fa29~mv2.jpg', 'Quartz 3'),
      `https://static.wixstatic.com/media/fab428_487744d9c2d940f6aa01e2488041c5a6~mv2.jpeg/v1/fill/w_820,h_560,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Quartz%204.jpeg`,
    ],
  },
  {
    name: 'Sintered Stone',
    description:
      'An engineered ultra-compact surface made from natural minerals fired at extreme heat. Non-porous, heat and UV resistant \u2014 ideal for modern kitchens, facades and outdoor use.',
    images: [
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/cowo2rnr_Sintered%20Stone%20sample%201.png',
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/tftee4j3_Sintered%20Stone%20sample%202.png',
    ],
  },
];

// Projects \u2014 Novena Church image is uploaded; others are elegant placeholders
// that will be swapped when the client uploads final images.
export const projects = [
  {
    title: 'Novena Church',
    category: 'Religious \u2022 Sanctuary Finishes',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/zqvkwm6v_Novena%20Church.jpeg',
  },
  {
    title: 'National Art Gallery',
    category: 'Cultural \u2022 Interior Stone',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/erorcc30_National%20Art%20Gallery.png',
  },
  {
    title: 'Mandarin Oriental Hotel',
    category: 'Hospitality \u2022 Luxury Interior',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/szd8n0k2_Mandarin%20Oriental%20Hotel.png',
  },
  {
    title: 'Andaz Hotel',
    category: 'Hospitality \u2022 Contemporary Stone',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/fesm6y1s_Andaz%20Hotel.jpeg',
  },
  {
    title: 'Office',
    category: 'Commercial \u2022 Corporate Interior',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/if3hkyst_Office.jpeg',
  },
  {
    title: 'Restaurant',
    category: 'F&B \u2022 Feature Marble & Bar',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/0ulkhi6f_Restuarant.png',
  },
  {
    title: 'Cafe',
    category: 'F&B \u2022 Stone Table Tops',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/9ak69xrv_Cafe.png',
  },
  {
    title: 'Residential 1',
    category: 'Residential \u2022 Kitchen & Bath',
    images: [
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/djnrgi0s_Residential%201_image%201.webp',
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/fp6g51rt_Residential%201_image%202.png',
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/be45xfy3_Residential%201_image%203.webp',
    ],
  },
  {
    title: 'Residential 2',
    category: 'Residential \u2022 Living Spaces',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/qvg5ntjd_Residential%202.png',
  },
];

export const clients = [
  'Architects & Interior Designers',
  'Builders',
  'Developers',
  'Hotels',
  'Contractors',
  'Homeowners',
];

export const stats = [
  { value: '25+', label: 'Years of Craft' },
  { value: '100+', label: 'Interior Designers & Homeowners Trust Us' },
  { value: '200+', label: 'Projects Delivered' },
];
